import Radium from 'radium';
import styles from './styles.less';
import WatchASLogo from 'common/components/watch-as-logo';
import { Link } from 'react-router';
import { observer } from 'mobx-react';


const EpisodeLink = Radium(Link);


function Episode(props) {
    const { video } = props;
    const className = cx(styles.root, props.className, {
        [styles.selected]: props.selected
    });
    const highlightedState = {
        backgroundColor: props.highlightColor,
        color: props.rolloverTextColor
    };
    return (
        <div className={ className }>
            <EpisodeLink
                className={ styles.link }
                onClick={ props.onClick }
                to={ video.url }
                style={[
                    !Modernizr.touch && { ':hover': highlightedState },
                    props.selected && highlightedState
                ]}>
                <div className={ styles.heading }>
                    { video.auth &&
                    <WatchASLogo
                        authenticated={ props.tveAuthenticated }
                        className={ styles.watchASLogo }
                    /> }
                    <h4 className={ styles.title }>
                        { !!video.identifier &&
                        <span className={ styles.identifier }>{ video.identifier }&nbsp;</span> }
                        { video.title }
                    </h4>
                </div>
                <p className={ styles.description }>
                    { video.description }
                </p>
            </EpisodeLink>
        </div>
    );
}

Episode.propTypes = {
    highlightColor: React.PropTypes.string,
    rolloverTextColor: React.PropTypes.string,
    selected: React.PropTypes.bool,
    tveAuthenticated: React.PropTypes.bool,
    video: React.PropTypes.object.isRequired
};

Episode.defaultProps = {
    selected: false,
    tveAuthenticated: false
};


export default observer(Radium(Episode));



/** WEBPACK FOOTER **
 ** ./src/show-page/components/episode/index.js
 **/